
export default {
  // Airport details
  "rank": "Rang",
  "hand_check_rate": "Taux de vérification manuelle",
  "reviews": "Avis",
  "loading_airport": "Chargement des détails de l'aéroport...",
  "airport_not_found": "Aéroport non trouvé",
  "airport_reviews": "Avis sur l'aéroport",
  "no_reviews_yet_share": "Pas encore d'avis",
  "share_film_community": "Partagez votre expérience avec la communauté argentique !",
  "add_review_button": "Ajouter un avis",
  "back_to_lenses": "Retour aux objectifs",
  "back_to_cameras": "Retour aux appareils",
  "failed_load_lens": "Échec du chargement des détails de l'objectif",
  "lens_not_found": "Objectif non trouvé",
  "favorite_airports": "Aéroports favoris",
  "no_favorite_airports": "Pas encore d'aéroports favoris",
  "user_favorites": "Favoris de l'utilisateur",
  "manage_favorites": "Gérer les favoris",
  "remove_from_favorites": "Retirer des favoris",
  "add_to_favorites": "Ajouter aux favoris",
  "airport_added_favorites": "Aéroport ajouté aux favoris",
  "airport_removed_favorites": "Aéroport retiré des favoris",
};
